export const REEL_CREATOR_DEMO_MODE = String(
  process.env.REACT_APP_REEL_CREATOR_DEMO_MODE ?? 'true'
).toLowerCase() !== 'false';

export const REEL_CREATOR_STAGES = ['Reference', 'Film', 'Upload', 'Creating Reel', 'Ready'];

export const PROJECT_STATES = Object.freeze([
  'draft',
  'reference_uploaded',
  'analysing_reference',
  'filming_required',
  'validating_clip',
  'filming_complete',
  'edit_queued',
  'editing',
  'quality_check',
  'ready',
  'failed'
]);

export const ACCEPTED_VIDEO_TYPES = Object.freeze(['video/mp4', 'video/quicktime', 'video/webm']);
export const MAX_VIDEO_BYTES = 250 * 1024 * 1024;

export const FILMING_SYSTEM_PROMPT = `You are an expert short-form video director.

Analyse the supplied reference Reel and determine the minimum footage the creator needs to film. Make every decision yourself. Reuse approved library footage and reuse one longer recording for several shots whenever an ordinary crop, zoom, or edit is enough.

Return strict structured JSON. For every required recording include: title, location, phonePosition, frame, startPosition, numbered physical steps, eyes, expression, and duration. Creator-facing instructions must be short, literal physical actions. Do not provide options or use unnecessary filmmaking terms.`;

export const EDITOR_SYSTEM_PROMPT = `Use the supplied reference Reel as the editing reference. Recreate its scene structure, shot duration, pacing, cut timing, framing pattern, transitions, text timing, and audio timing as closely as reasonably possible using the approved footage. Prioritise real footage. Do not unnecessarily regenerate or alter the subject. Maintain identity, clothing, hair, and body consistency. Output a vertical short-form video suitable for Instagram Reels.`;

export const creatorErrorMessage = (operation) => ({
  analyse: "We couldn't analyse this Reel. Please upload it again.",
  upload: "We couldn't upload this video. Please try again.",
  edit: "We couldn't finish this Reel automatically.",
  load: "We couldn't load your Reels. Please try again."
}[operation] || 'Something went wrong. Please try again.');

